import { IBaseAction } from '../../../../common/interfaces/IBaseAction';
export enum Keys {
    LOADACTIVITIES = 'react/activities/LOADACTIVITIES',
    LOADACTIVITIES_PENDING = 'react/activities/LOADACTIVITIES_PENDING',
    LOADACTIVITIES_FULFILLED = 'react/activities/LOADACTIVITIES_FULFILLED',
    LOADACTIVITIES_REJECTED = 'react/activities/LOADACTIVITIES_REJECTED',

    SAVENEWACTIVITY = 'react/activities/SAVENEWACTIVITY',
    SAVENEWACTIVITY_PENDING = 'react/activities/SAVENEWACTIVITY_PENDING',
    SAVENEWACTIVITY_FULFILLED = 'react/activities/SAVENEWACTIVITY_FULFILLED',
    SAVENEWACTIVITY_REJECTED = 'react/activities/SAVENEWACTIVITY_REJECTED',

    SELECTACTIVITY = 'react/activities/SELECTACTIVITY',
    SELECTACTIVITY_PENDING = 'react/activities/SELECTACTIVITY_PENDING',
    SELECTACTIVITY_FULFILLED = 'react/activities/SELECTACTIVITY_FULFILLED',
    SELECTACTIVITY_REJECTED = 'react/activities/SELECTACTIVITY_REJECTED',

    UPDATEACTIVITY = "react/activities/UPDATEACTIVITY",
    
    SAVEACTIVITY = 'react/activities/SAVEACTIVITY',
    SAVEACTIVITY_PENDING = 'react/activities/SAVEACTIVITY_PENDING',
    SAVEACTIVITY_FULFILLED = 'react/activities/SAVEACTIVITY_FULFILLED',
    SAVEACTIVITY_REJECTED = 'react/activities/SAVEACTIVITY_REJECTED',
    
    DELETEACTIVITY = "react/activities/DELETEACTIVITY",
    DELETEACTIVITY_PENDING = 'react/activities/DELETEACTIVITY_PENDING',
    DELETEACTIVITY_FULFILLED = 'react/activities/DELETEACTIVITY_FULFILLED',
    DELETEACTIVITY_REJECTED = 'react/activities/DELETEACTIVITY_REJECTED',

    SAVESCHEDULE = 'react/activities/SAVESCHEDULE',
    SAVESCHEDULE_PENDING = 'react/activities/SAVESCHEDULE_PENDING',
    SAVESCHEDULE_FULFILLED = 'react/activities/SAVESCHEDULE_FULFILLED',
    SAVESCHEDULE_REJECTED = 'react/activities/SAVESCHEDULE_REJECTED',

    DELETESCHEDULE = "react/activities/DELETESCHEDULE",
    DELETESCHEDULE_PENDING = 'react/activities/DELETESCHEDULE_PENDING',
    DELETESCHEDULE_FULFILLED = 'react/activities/DELETESCHEDULE_FULFILLED',
    DELETESCHEDULE_REJECTED = 'react/activities/DELETESCHEDULE_REJECTED',

    CREATESCHEDULE = "react/activities/CREATESCHEDULE",
    CREATESCHEDULE_PENDING = 'react/activities/CREATESCHEDULE_PENDING',
    CREATESCHEDULE_FULFILLED = 'react/activities/CREATESCHEDULE_FULFILLED',
    CREATESCHEDULE_REJECTED = 'react/activities/CREATESCHEDULE_REJECTED',
    
    DELETESCHEDULES = "react/activities/DELETESCHEDULES",
    DELETESCHEDULES_PENDING = 'react/activities/DELETESCHEDULES_PENDING',
    DELETESCHEDULES_FULFILLED = 'react/activities/DELETESCHEDULES_FULFILLED',
    DELETESCHEDULES_REJECTED = 'react/activities/DELETESCHEDULES_REJECTED',

    CREATESCHEDULES = "react/activities/CREATESCHEDULES",
    CREATESCHEDULES_PENDING = 'react/activities/CREATESCHEDULES_PENDING',
    CREATESCHEDULES_FULFILLED = 'react/activities/CREATESCHEDULES_FULFILLED',
    CREATESCHEDULES_REJECTED = 'react/activities/CREATESCHEDULES_REJECTED',

    ADDRESERVATION= 'react/activities/ADDRESERVATION',
    ADDRESERVATION_FULFILLED= 'react/activities/ADDRESERVATION_FULFILLED',
    ADDRESERVATION_REJECTED= 'react/activities/ADDRESERVATION_REJECTED',
    ADDRESERVATION_PENDING= 'react/activities/ADDRESERVATION_PENDING',

    REMOVERESERVATION= 'react/activities/REMOVERESERVATION',
    REMOVERESERVATION_FULFILLED= 'react/activities/REMOVERESERVATION_FULFILLED',
    REMOVERESERVATION_REJECTED= 'react/activities/REMOVERESERVATION_REJECTED',
    REMOVERESERVATION_PENDING= 'react/activities/REMOVERESERVATION_PENDING',

    OTHER_ACTION = 'react/activities/__any_other_action__',
}

export type Types = IBaseAction<Keys>;